/** Macro #25 Analytics — presentation-only formatting helpers. */

const MICRO = 1_000_000;

/** Integer micro-USDC → compact USDC string (no fabricated precision). */
export function usdc(micro: number): string {
  const v = (micro || 0) / MICRO;
  if (v >= 1000) return v.toLocaleString(undefined, { maximumFractionDigits: 0 });
  return v.toLocaleString(undefined, { maximumFractionDigits: 2 });
}

export function fmtInt(n: number): string {
  return (n || 0).toLocaleString();
}

export const RANGE_LABELS: Array<[import("../lib/analytics-api").Range, string]> = [
  ["7d", "7D"],
  ["30d", "30D"],
  ["90d", "90D"],
  ["all", "All"],
];
